import {
    SET_APP_SESSION_ID,
    SET_VIDEO_SESSION_ID,
} from 'store/session/constants';

import { SessionState } from './reducer.types';

export const setAppSessionId = (sessionId: SessionState['appSessionId']) => ({
    type: SET_APP_SESSION_ID,
    payload: {
        sessionId,
    },
});

export const setVideoSessionId = (
    sessionId: SessionState['videoSessionId'],
) => ({
    type: SET_VIDEO_SESSION_ID,
    payload: {
        sessionId,
    },
});
